import join from 'url-join';
import { ArticleFragmentResponse } from '../../../../fragments/article';
import useDefaultMetadata from '../../../DefaultSeo/useDefaultMetadata';
import useSiteMetadata from '../../../Seo/useSiteMetadata';
import { PRIMARY_IMAGE_HASH } from './useImageObject';
import { WEBPAGE_HASH } from './useWebpageObject';

export const ARTICLE_HASH = '#article';

const useArticleObject = (article: ArticleFragmentResponse) => {
  const { siteUrl } = useSiteMetadata();
  const { ogImage } = useDefaultMetadata();
  const { title, slug, publication_date, _createdAt, _updatedAt } = article;

  if (slug?.current) {
    return {
      '@type': 'Article',
      '@id': join(siteUrl, slug.current, ARTICLE_HASH),
      isPartOf: {
        '@type': 'WebPage',
        '@id': join(siteUrl, slug.current, WEBPAGE_HASH),
      },
      headline: title,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': join(siteUrl, slug.current, WEBPAGE_HASH),
      },
      image: {
        '@type': 'ImageObject',
        '@id': join(siteUrl, slug.current, PRIMARY_IMAGE_HASH),
      },
      author: {
        '@type': 'Person',
        name: process.env.ARTICLE_AUTHOR || 'Noëlla de Gojob',
      },
      datePublished: publication_date || _createdAt,
      dateModified: _updatedAt,
      publisher: {
        '@type': 'Organization',
        logo: {
          '@type': 'ImageObject',
          url: ogImage?.asset?.localFile?.childImageSharp?.original?.src,
        },
        name: 'Gojob',
      },
    };
  }
};

export default useArticleObject;
